/** @format */

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { FilterAccordionComponent } from '../filter-accordion/filter-accordion.component';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { ProductListSEO } from '@shared/data-access/interfaces';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'shared-components-seo-content',
  imports: [TitleCasePipe, HmfTextLinkComponent, FilterAccordionComponent],
  templateUrl: './seo-content.component.html',
  styleUrl: './seo-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeoContentComponent {
  readonly productListSEOData = input.required<Pick<
    ProductListSEO,
    'sanitizedAttributes'
  > | null>();

  readonly seoTabContentList = computed(
    () => this.productListSEOData()?.sanitizedAttributes?.seoTabsContent || [],
  );

  readonly hasSeoTabContent = computed(() => this.seoTabContentList()?.length > 0);
  readonly seoHeader = computed(() => this.productListSEOData()?.sanitizedAttributes?.seoHeadline);

  readonly featuredLinks = computed(
    () => this.productListSEOData()?.sanitizedAttributes?.seoFeaturedLinks || [],
  );

  readonly hasFeaturedLinks = computed(() => this.featuredLinks()?.length > 0);
  readonly hasSeoContent = computed(() => this.hasSeoTabContent() || this.hasFeaturedLinks());

  trackByHeader(index: number, header: string): string {
    return index.toString() + header;
  }

  trackByKey(index: number, key: string): string {
    return index.toString() + key;
  }
}
